// extracted by mini-css-extract-plugin
export default {"container":"ForgotPassword_container__uQTL0","content":"ForgotPassword_content__hQfIm","image":"ForgotPassword_image__P4XV+"};